var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlignleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: props.fill,
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.95a.8.8 0 01.8.8v16.5a.8.8 0 01-1.6 0V3.75a.8.8 0 01.8-.8zM7.55 14.3v3.65H20.2V14.3zm-1.6-.05c0-.856.694-1.55 1.55-1.55h12.75c.856 0 1.55.694 1.55 1.55V18a1.55 1.55 0 01-1.55 1.55H7.5A1.55 1.55 0 015.95 18zM7.55 6.05V9.7h8.9V6.05zM5.95 6c0-.856.694-1.55 1.55-1.55h9c.856 0 1.55.694 1.55 1.55v3.75a1.55 1.55 0 01-1.55 1.55h-9a1.55 1.55 0 01-1.55-1.55z"
  }))));
}

export default SvgAlignleft;